import { apiRequest } from "./client";
import type {
  AcademyRole,
  UserCreated,
  UserDetail,
  UserList,
  UserListItem,
} from "../types/user";

export interface ListParams {
  role?: AcademyRole;
  status?: "active" | "inactive" | "deleted";
  q?: string;
  page?: number;
  page_size?: number;
}

function qs(params: ListParams): string {
  const u = new URLSearchParams();
  if (params.role) u.set("role", params.role);
  if (params.status) u.set("status", params.status);
  if (params.q) u.set("q", params.q);
  if (params.page) u.set("page", String(params.page));
  if (params.page_size) u.set("page_size", String(params.page_size));
  const s = u.toString();
  return s ? `?${s}` : "";
}

export function listUsers(params: ListParams = {}): Promise<UserList> {
  return apiRequest<UserList>(`/users${qs(params)}`);
}

export function getUser(id: number): Promise<UserDetail> {
  return apiRequest<UserDetail>(`/users/${id}`);
}

export interface CreateUserPayload {
  login: string;
  full_name: string;
  phone?: string;
  telegram_user_id?: number;
  role: AcademyRole;
}

export function createUser(payload: CreateUserPayload): Promise<UserCreated> {
  return apiRequest<UserCreated>("/users", { method: "POST", body: payload });
}

export interface ResetPasswordResult {
  generated_password: string;
}

export function resetPassword(id: number): Promise<ResetPasswordResult> {
  return apiRequest<ResetPasswordResult>(`/users/${id}/reset-password`, {
    method: "POST",
  });
}

export function deleteUser(id: number): Promise<void> {
  return apiRequest<void>(`/users/${id}`, { method: "DELETE" });
}

export function restoreUser(id: number): Promise<void> {
  return apiRequest<void>(`/users/${id}/restore`, { method: "POST" });
}

export function setSandbox(id: number, isSandbox: boolean): Promise<UserDetail> {
  return apiRequest<UserDetail>(`/users/${id}/sandbox`, {
    method: "POST",
    body: { is_sandbox: isSandbox },
  });
}

export function grantRole(id: number, role: AcademyRole): Promise<void> {
  return apiRequest<void>(`/users/${id}/roles`, {
    method: "POST",
    body: { role },
  });
}

export function revokeRole(id: number, role: AcademyRole): Promise<void> {
  return apiRequest<void>(`/users/${id}/roles/${role}`, { method: "DELETE" });
}

export type { UserListItem };
